import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SPLASH_SCREEN_KEY = 'splash_screen_shown';

const useSplashScreen = () => {
  const [hasShownSplash, setHasShownSplash] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [domReady, setDomReady] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Only show splash screen on root route
    if (location.pathname === '/') {
      // Always show splash screen on root route (removed sessionStorage check)
      setHasShownSplash(false);
      setIsLoading(true);
      setDomReady(false);
      setShowContent(false);
    } else {
      // Not on root route, never show splash screen
      setHasShownSplash(true);
      setIsLoading(false);
      setDomReady(true);
      setShowContent(true);
    }
  }, [location.pathname]);

  // Handle DOM readiness callback from SplashScreen
  const handleDOMReady = () => {
    setDomReady(true);
    // Wait a bit more to ensure everything is properly loaded
    setTimeout(() => {
      setShowContent(true);
      setIsLoading(false);
      // Removed sessionStorage setting to allow splash screen on every visit
    }, 300);
  };

  // Determine if splash screen should be shown - only on root route
  const shouldShowSplash = location.pathname === '/' && !hasShownSplash && (isLoading || !domReady || !showContent);

  return {
    shouldShowSplash,
    isLoading,
    domReady,
    showContent,
    handleDOMReady,
    hasShownSplash
  };
};

export default useSplashScreen;
